import React, { useState, useEffect, useRef } from 'react';
import { motion, useAnimation } from 'framer-motion';
import './Clients.css';
import tecVacaLogo from '../assets/clientes-parceiros/logo tecvacaprodutiva.png'

const Clients = () => {
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);
  const trackRef = useRef(null);
  const controls = useAnimation();

  // Adicione suas logos reais aqui
  const clients = [
    { id: 1, name: "Geterr", logo: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=500,h=500,fit=crop/AQEZ1LkgN2FkZNEZ/geterr_v_ass-A1a5k7aVnouKJ1OM.png" },
    { id: 2, name: "Tec Vaca Produtiva", logo: tecVacaLogo },
    { id: 3, name: "Projeto EcoPeixe", logo: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=432,fit=crop,q=95/Yanq66yBg1HXvx63/ecopeixe-hortizxontal-A3QwMERJ4XfnKoD7.jpg" },
    { id: 4, name: "TecnoPARQ", logo: "https://centev.ufv.br/wp-content/uploads/2022/09/tecnoPARQ-Positive.png" },
    { id: 5, name: "Centev/UFV", logo: "https://centev.ufv.br/wp-content/uploads/2022/02/rodape-duplo-1-1024x366.png" }
  ];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [scrollPx, setScrollPx] = useState(0);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Duplicar logos para efeito infinito
  const minDuplication = 6;
  const infiniteClients = Array(minDuplication).fill(clients).flat();

  // Largura de cada logo em px (aproximado)
  const logoGap = windowWidth <= 480 ? 16 : windowWidth <= 768 ? 24 : 40; // gap em px
  const logoWidth = windowWidth <= 480 ? 80 : windowWidth <= 768 ? 100 : 140; // largura média de cada logo
  const totalItems = infiniteClients.length;
  const trackWidthPx = totalItems * (logoWidth + logoGap);

  // Velocidade em px/segundo
  const SPEED_PX_PER_SEC = 200; // ajuste aqui para mais rápido/lento

  useEffect(() => {
    if (!isAutoPlaying || isDragging) return;
    let req;
    let lastTime = performance.now();
    let localScroll = scrollPx;
    const animate = (now) => {
      const delta = now - lastTime;
      lastTime = now;
      localScroll -= (SPEED_PX_PER_SEC * (delta / 1000));
      // Quando passar metade do track, reseta para zero (sem animação)
      if (Math.abs(localScroll) >= (trackWidthPx / 2)) {
        localScroll = 0;
        setScrollPx(0);
        controls.set({ x: 0 });
      } else {
        setScrollPx(localScroll);
        controls.set({ x: localScroll });
      }
      req = requestAnimationFrame(animate);
    };
    req = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(req);
    // eslint-disable-next-line
  }, [isAutoPlaying, isDragging, trackWidthPx, SPEED_PX_PER_SEC]);

  const handleMouseEnter = () => setIsAutoPlaying(false);
  const handleMouseLeave = () => setIsAutoPlaying(true);

  return (
    <section id="clientes" className="section clients-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Clientes e Parceiros</h2>
          <p className="section-subtitle">Empresas que confiam na MicroCodie</p>
        </motion.div>

        <motion.div
          className="clients-carousel logos-only"
          ref={containerRef}
          role="region"
          aria-label="Carrossel de clientes e parceiros"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          drag="x"
          dragConstraints={{ left: 0, right: 0 }}
          dragElastic={0.1}
          onDragStart={() => setIsDragging(true)}
          onDragEnd={() => setIsDragging(false)}
          style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
        >
          <motion.div
            className="clients-logos-track"
            ref={trackRef}
            animate={controls}
            transition={{ type: "tween", ease: "linear", duration: 0.05 }}
            style={{ width: trackWidthPx + 'px', display: 'flex', alignItems: 'center', gap: logoGap + 'px' }}
          >
            {infiniteClients.map((client, index) => (
              <div
                key={`${client.id}-${index}`}
                className="client-logo-item"
                style={{ width: logoWidth + 'px', minWidth: logoWidth + 'px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <img
                  src={client.logo}
                  alt={`Logo ${client.name}`}
                  loading="lazy"
                  className="client-logo-img"
                  style={{ maxHeight: 60, maxWidth: '90%', objectFit: 'contain', filter: 'grayscale(100%)', transition: 'filter 0.3s' }}
                  onMouseOver={e => e.currentTarget.style.filter = 'grayscale(0%)'}
                  onMouseOut={e => e.currentTarget.style.filter = 'grayscale(100%)'}
                />
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    <section className="clients-cta" aria-label="Chamada para ação - Seja um cliente MicroCodie">
      <div className="cta-content">
        <h3>Seja um parceiro da MicroCodie</h3>
        <a 
          href="#contato" 
          className="btn"
          aria-label="Ir para a página de contato da MicroCodie"
        >
          Entre em contato
        </a>
      </div>
    </section>
    </section>
  );
};

export default Clients; 